import { useFormik } from "formik";
import React, { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Button from '../../../component/button/Button';
import InputField from "../../../component/InputField/InputField";
import InputPhoneField from '../../../component/inputPhonefield/InputPhoneField';
import SocialLogin from '../../../component/socialLogin/SocialLogin';
import { userData } from '../../../config/sessionKeys';
import siteConfig from '../../../config/site-config';
import { emailRegex, goToLiveSession, pageTitle, setSessionStorage, TranslateErrorFormMessage } from '../../../helper/CommonFunctions';
import ApiUrlServices from '../../../networks/ApiUrlServices';
import AxiosServices from '../../../networks/AxiosService';
import path from '../../../routes/path';
import { userAction } from "../../../store/userSlice";
import '../static/Auth.scss';
import { bookCartAction } from "../../../store/bookCartSlice";

const qs = require('query-string');

const Login = (props) => {
    const navigate = useNavigate();
    const { search } = window?.location;
    const queryParams = qs.parse(search);
    const parsed = qs.parse(window.location.search);
    const location = useLocation()
    const { t } = useTranslation()

    const [isLoading, setLoading] = useState(false);
    const [EmailorPhone, setEmailorPhone] = useState('');
    const [medium, setMedium] = useState(parsed['as-instructor'] === '1024' ? "email" : "phone");
    const dispatch = useDispatch();
    const cartData = useSelector(state => state.cartReducer.cartData);
    const BookCartData = useSelector(state => state.bookCartReducer.bookCartData);
    const [verify, setVerify] = useState(false)
    const [sendEmailAgain, setSendEmailAgain] = useState(false);
    const [onlyNumber, setOnlyNumber] = useState('')
    const [onlyCountryCode, setOnlyCountryCode] = useState('');
    useEffect(() => {
        if (props.pageTitle !== undefined) {
            pageTitle(props.pageTitle);
        }
    }, [props.pageTitle])
    useEffect(() => {
        console.log('parsed', parsed, location)
    }, [parsed])

    function handleEmailOrPhone(e) {
        const { name, value } = e.target;
        loginFormik.resetForm();
        loginFormik.setErrors({}); // clear all errors
        medium === "email" ? setMedium("phone") : setMedium("email");
    }

    function handleChangePhone(e) {
        loginFormik.setFieldValue("email", e);
    }

    // validateLoginForm
    const validateLoginForm = (values) => {
        const errors = {};
        const trimmedEmail = values.email.trim();
        const trimmedPassword = values.password.trim();

        if (medium === "phone" && (trimmedEmail.length > 11 || trimmedEmail.length < 11) && parseInt(trimmedEmail[0]) === 1) errors.email = t("ALL_MESSAGE.phone_number_should_be_10_digits");
        if (medium === "phone" && (trimmedEmail.length > 13 || trimmedEmail.length < 13) && parseInt(trimmedEmail[2]) === 0) errors.email = t("ALL_MESSAGE.enter_a_valid_whatsapp_mobile_number");
        if (medium === "phone" && (trimmedEmail.length < 5)) errors.email = t("ALL_MESSAGE.enter_a_valid_whatsapp_mobile_number");
        if (medium === "phone" && Number(onlyNumber[0]) === 0) errors.email = t("ALL_MESSAGE.first_digit_must_be_except");
        if (medium === "phone" && Number(onlyCountryCode) === 880) {
            if (Number(onlyNumber[0]) !== 1) {
                errors.email = t("ALL_MESSAGE.enter_a_valid_whatsapp_mobile_number");
            }
        }
        if (medium === "phone" && !trimmedEmail) errors.email = t("ALL_MESSAGE.whatsapp_mobile_number_is_required");

        if (medium === "email") {
            if (!trimmedEmail) {
                errors.email = t('ALL_MESSAGE.email_is_required');
            } else if (!emailRegex.test(trimmedEmail)) {
                errors.email = t('ALL_MESSAGE.invalid_email_address');
            }
        }

        if (!trimmedPassword) {
            errors.password = t('ALL_MESSAGE.password_is_required');
        } else {
            if (trimmedPassword.length < 6) {
                errors.password = t('ALL_MESSAGE.password_should_be_at_least_6');
            }
            if (trimmedPassword.includes(" ")) {
                errors.password = t('ALL_MESSAGE.password_cant_contain_white_space');
            }
        }

        return errors;
    };

    // From Submit Functions
    const submitForm = async (values) => {
        setLoading(true)
        let emailOrPhone = values.email;
        setEmailorPhone(emailOrPhone);
        emailOrPhone = medium === "phone" ? "+" + emailOrPhone : emailOrPhone;
        const data = {
            medium: medium,
            emailOrPhone: emailOrPhone.trim(),
            password: values.password.trim(),
        };

        try {

            let response = await AxiosServices.post(ApiUrlServices.SIGN_IN, data, false);

            // Don't allow admin user to the client system. . .
            if (response.data.data.role.includes('admin')) {
                localStorage.clear()
                toast.error(t('ALL_MESSAGE.admin_can_not_login_to_this_system'));
                setLoading(false);
                navigate(`${process.env.PUBLIC_URL}${path.login}`);
            }
            else {
                let stored = response.status === 200 ? setSessionStorage(userData, response.data.data) : "";

                if (stored) {
                    dispatch(userAction.setSessionData(response.data.data));
                    localStorage.setItem("selectedRole", siteConfig.userRoles[0]);
                    localStorage.setItem(userData, JSON.stringify(response.data.data));
                    // navigate(`${process.env.PUBLIC_URL}${path.view_profile}`);
                    if (location.state !== null) {
                        const cartLocation = location?.state?.from.split("/")[1] === 'courses-details'
                        const BookCartLocation = location?.state?.from.split("/")[1] === 'home' || location?.state?.from.split("/")[2] === 'publications' || location?.state?.from.split("/")[2] === 'book-details'
                        console.log('cartLocation', location, cartLocation, BookCartLocation)
                        if ((Object.values(cartData || {})).length && cartLocation) {
                            console.log("Cart Data")
                            navigate({
                                pathname: path.cart,
                                search: "?cartPendingData=true"
                            })
                        }
                        if ((Object.values(BookCartData || {})).length && BookCartLocation) {
                            console.log("book Cart Data")
                            navigate({
                                pathname: path.book_cart,
                                search: "?cartPendingData=true"
                            })
                            dispatch(bookCartAction.setBookCartValue(0));
                        }
                    }

                    else if (queryParams && Object.entries(queryParams).length) {
                        if (queryParams.sessionRedirect) {
                            const password = queryParams.password || null;
                            const isLiveSession = queryParams.isLiveSession || null;
                            const { userId, name, idToken, refreshToken, myEmail } = response.data.data;
                            goToLiveSession(queryParams.sessionRedirect, userId, idToken, refreshToken, name, myEmail, password, isLiveSession, "_self");
                            // navigate(path.view_profile);
                        }
                        else {
                            let myDynamicPath = "";
                            const url = queryParams.redirect_to;
                            if (Object.entries(queryParams).length) {
                                for (const [key, value] of Object.entries(queryParams)) {
                                    if (key === "redirect_to" || !key || !value) {
                                        continue;
                                    }
                                    myDynamicPath += `${myDynamicPath ? "&" : "?"}${key}=${value}`;
                                }
                            }
                            navigate({
                                pathname: url,
                                search: myDynamicPath
                            });
                        }
                    }

                    else {
                        console.log("Normal Data")
                        navigate(path.view_profile);
                    }
                }
            }
            props?.setLoginSidebar(false)
            setLoading(false)
        } catch (error) {
            setLoading(false)
            console.log(error)
            if (error.response.data.code === "ACCOUNT_BLOCKED") {
                if (error.response.data.code) {
                    loginFormik.errors.email = `${t('ALL_MESSAGE.login.ACCOUNT_BLOCKED')}`;
                }
            } else if (error.response.data.code === "USER_NOT_CONFIRMED") {
                if (error.response.data.code) {
                    setVerify(true)
                    medium === "email" ?
                        loginFormik.errors.email = `${t('ALL_MESSAGE.login.USER_NOT_CONFIRMED.email')}` :
                        loginFormik.errors.email = `${t('ALL_MESSAGE.login.USER_NOT_CONFIRMED.phone')}`
                }
            } else if (error.response.data.code === "GENERIC") {
                loginFormik.errors.email = `${t('ALL_MESSAGE.USER_NOT_FOUND')}`
            }
            else if (error.response.data.code === "USER_NOT_FOUND") {
                loginFormik.errors.email = `${t('ALL_MESSAGE.USER_NOT_FOUND')}`
            }
            else if (error.response.data.code === "TOO_MANY_REQUESTS") {
                loginFormik.errors.email = `${t('ALL_MESSAGE.TOO_MANY_REQUESTS')}`
            } else if (error.response.data.code === "SIGNIN_NOT_AUTHORIZED") {
                loginFormik.errors.email = `${t('ALL_MESSAGE.Incorrect_username_or_password')}`
            }
            else if (error.response.data.code === "ACCOUNT_DELETED") {
                loginFormik.errors.email = `${t('ALL_MESSAGE.account_deleted')}`
            }
            else {
                loginFormik.errors.email = `${t('ALL_MESSAGE.something_went_wrong')}`
            }

            // server side error message
            loginFormik.setSubmitting(false);
        }
    }


    const sendEmil = () => {
        setSendEmailAgain(true)
        let emailOrPhone = EmailorPhone;
        emailOrPhone = medium === "phone" ? "+" + emailOrPhone : emailOrPhone;
        const registrationData = {
            medium: medium,
            emailOrPhone: emailOrPhone,
        };

        AxiosServices.post(ApiUrlServices.RESEND_CONFIRMATION_CODE, registrationData, false)
            .then((response) => {
                dispatch(userAction.setRegisterData(registrationData));
                toast.success(emailOrPhone === "email" ? `${t('ALL_MESSAGE.mobile_sent_to')} ${emailOrPhone}`
                    : `${t('ALL_MESSAGE.email_sent_to')} ${emailOrPhone}`);
                setSendEmailAgain(false);
                let data = response.data.message;
                if (medium === 'email') {
                    navigate({
                        pathname: path.registration_confirmation,
                        state: { data: data, registrationData: registrationData }
                    })
                } else {
                    navigate({
                        pathname: path.registration_phone_confirmation,
                        state: { data: data, registrationData: registrationData }
                    })
                }
            })
            .catch(err => {
                console.log(err)
                if (err.response.data.code === "GENERIC") {
                    toast.error(` ${t('ALL_MESSAGE.user_is_already_confirmed')}`);
                }
                if (err.response.data.code === "LIMIT_EXCEEDED_EXCEPTION") {
                    toast.error(`${t('ALL_MESSAGE.attempt_limit_exceeded')}`)
                } else if (err.response.data.code === "TOO_MANY_REQUESTS") {
                    toast.error(`${t('ALL_MESSAGE.TOO_MANY_REQUESTS')}`)
                } else if (err.response.data.code === "USER_NOT_FOUND") {
                    toast.error(`${t('ALL_MESSAGE.USER_NOT_FOUND')}`)
                } else if (err.response.data.code === "CODE_DELIVERY_FAILED") {
                    toast.error(`${t('ALL_MESSAGE.failed_to_deliver_account_confirmation')}`)
                } else {
                    toast.error(`${t('ALL_MESSAGE.something_went_wrong')}`)
                }
                setSendEmailAgain(false);
            })

    }


    // Formik Valiadations
    const loginFormik = useFormik({
        initialValues: {
            email: "",
            password: "",
        },
        validateOnChange: true,
        validateOnBlur: true,
        validate: validateLoginForm,
        onSubmit: submitForm
    });
    TranslateErrorFormMessage(loginFormik);


    return (
        <div className="login-register-wrapper">
            <form onSubmit={loginFormik.handleSubmit}>
                {medium === "email" ? (
                    <InputField
                        id="email"
                        label={t('auth_page.email')}
                        className="mb-10"
                        labelLinkText={t('auth_page.try_mobile_number')}
                        labelOnChangeCallback={handleEmailOrPhone}
                        placeholder={t('auth_page.email')}
                        textType="email"
                        inputName="email"
                        asterisk={true}
                        whiteSpace={false}
                        onBlur={loginFormik.handleBlur}
                        value={loginFormik.values.email}
                        onchangeCallback={loginFormik.handleChange}
                        inputClassName={loginFormik.touched.email && loginFormik.errors.email ? " is-invalid" : ""}
                        requiredMessage={loginFormik.touched.email && loginFormik.errors.email}
                        requiredMessageLabel={loginFormik.touched.email || loginFormik.isSubmitting ? loginFormik.errors.email : ""}
                    />
                ) : (
                    <InputPhoneField
                        country={"bd"}
                        value={loginFormik.values.email}
                        className="mb-10"
                        inputName="email"
                        inputLabel={t('auth_page.mobible_number')}
                        labelLinkText={t('auth_page.try_email')}
                        labelOnChangeCallback={handleEmailOrPhone}
                        countryCodeEditable={false}
                        asterisk={true}
                        whiteSpace={false}
                        onBlur={loginFormik.handleBlur}
                        onchangeCallback={(e, value) => {
                            const dialCode = value?.dialCode || "";
                            let phoneNumberWithoutCountryCode = e;
                            if (dialCode && e.startsWith(`${dialCode}`)) {
                                phoneNumberWithoutCountryCode = e.slice(dialCode.length);
                            }
                            setOnlyNumber(phoneNumberWithoutCountryCode);
                            setOnlyCountryCode(dialCode);
                            // Set the full number back into the formik value
                            loginFormik.setFieldValue('email', e);
                        }}
                        inputClassName={loginFormik.touched.email && loginFormik.errors.email ? " is-invalid" : ""}
                        requiredMessage={loginFormik.touched.email && loginFormik.errors.email}
                        requiredMessageLabel={loginFormik.touched.email || loginFormik.isSubmitting ? loginFormik.errors.email : ""}
                    />
                )}

                <div className="single-condition-field mb-30">
                    <InputField
                        type="password"
                        placeholder={t('auth_page.password')}
                        label={`${t('auth_page.password')}`}
                        labelLinkText={t('auth_page.forget_password')}
                        labelLink={`${process.env.PUBLIC_URL}${path.forget_password}`}
                        inputName="password"
                        value={loginFormik.values.password}
                        asterisk={true}
                        whiteSpace={false}
                        onBlur={loginFormik.handleBlur}
                        inputValue={loginFormik.values.password}
                        onchangeCallback={loginFormik.handleChange}
                        inputClassName={loginFormik.touched.password && loginFormik.errors.password ? " is-invalid" : ""}
                        requiredMessage={loginFormik.touched.password && loginFormik.errors.password}
                        requiredMessageLabel={loginFormik.touched.password || loginFormik.isSubmitting ? loginFormik.errors.password : ""}

                    />

                </div>
                <Button
                    btnText={t('auth_page.login')}
                    onclickCallback={loginFormik.handleSubmit}
                    disabled={isLoading}
                    isLoading={isLoading}
                    type="submit"
                    btnClassName="login-btn"
                />
                {
                    verify ?
                        <div className="redirect-other-page d-flex mt-10">
                            <span className="not-a-member mr-1">{medium === "email" ? t('register_complete_page.dint_get_the', { text: t('register_complete_page.email') }) : t('register_complete_page.dint_get_the', { text: t('register_complete_page.otp') })}? </span>
                            <a href={void (0)} style={{ display: 'block', cursor: 'pointer' }}
                                className={sendEmailAgain ? 'disabled disabled-border-none' : ''}
                                onClick={sendEmailAgain ? () => void 0 : (e) => {
                                    sendEmil();
                                    e.preventDefault();
                                }}> <span style={{ marginLeft: '3px' }}>{sendEmailAgain ? t('register_complete_page.sending') : t('register_complete_page.sent_again')}</span>
                            </a>
                        </div>

                        : null
                }
            </form>
            <SocialLogin />
            <div className="f-text-ff">
                <p>
                    {t('auth_page.don_have_account')} {
                        props.loginSidebar ?
                            <Link onClick={() => props?.setLoginSidebar(false)} to={`${process.env.PUBLIC_URL}${path.registration}`} className="text-primary">{t('auth_page.sign_up')}</Link> :
                            <Link to={`${process.env.PUBLIC_URL}${path.registration}`} className="text-primary">{t('auth_page.sign_up')}</Link>
                    } </p>
            </div>
        </div>
    )
}
export default Login;
